import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import { LanguageProvider } from "@/i18n";
import { ROUTES } from "@/legal";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/en" element={<Home />} />
            <Route path="/en/" element={<Home />} />
            <Route path={ROUTES.legal} element={<LegalPage docKey="legal" />} />
            <Route path={ROUTES.privacy} element={<LegalPage docKey="privacy" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
